import { connect } from 'react-redux'
import {
  GRANT_TOKEN_REQUEST,
  REVOKE_TOKEN_REQUEST
} from '@ocean-club/dapps/dist/modules/authorization/actions'
import { getData as getAuthorizations } from '@ocean-club/dapps/dist/modules/authorization/selectors'
import { isLoadingType } from '@ocean-club/dapps/dist/modules/loading/selectors'
import { getLoading } from '@ocean-club/dapps/dist/modules/authorization/selectors'
import { RootState } from '../../modules/reducer'
import {
  MapStateProps,
  MapDispatchProps,
  MapDispatch
} from './AuthorizationModal.types'
import AuthorizationModal from './AuthorizationModal'

const mapState = (state: RootState): MapStateProps => ({
  authorizations: getAuthorizations(state),
  isAuthorizing:
    isLoadingType(getLoading(state), GRANT_TOKEN_REQUEST) ||
    isLoadingType(getLoading(state), REVOKE_TOKEN_REQUEST)
})

const mapDispatch = (_dispatch: MapDispatch): MapDispatchProps => ({})

export default connect(mapState, mapDispatch)(AuthorizationModal)
